import { useMutation } from '@redwoodjs/web';
import { useState } from 'react';
import { showErrorToast } from 'src/components/Toasts/toast';
import { DELETE_SEPA_DD_MANDATE_AGREEMENT } from 'src/graphql/mutations/sepaMandate.mutation';
import { onError } from 'src/utils/utils';

export function useDeleteSepaAgreement({ handleOnDeleteSepaMandate }) {
    const [idToDelete, setIdToDelete] = useState();

    const [deleteSepaMandate] = useMutation(DELETE_SEPA_DD_MANDATE_AGREEMENT, {
        onError,
        onCompleted: (data) => {
            handleOnDeleteSepaMandate(data);
        },
    });

    const handleDeleteSepaMandate = (id: number) => {
        if (idToDelete) {
            deleteSepaMandate({
                variables: {
                    id: idToDelete,
                },
            });
        } else {
            showErrorToast('Failed to delete SEPA DD Mandate.');
        }
    };

    return {
        handleDeleteSepaMandate,
        setIdToDelete,
    };
}
